// Generado por scripts/vendor-fonts.mjs. No editar a mano.
import type { V46FontProfile } from './types.ts';

export const V46_FONT_PROFILES = [
  {
    "id": "v46-montserrat-600-normal",
    "fontAssetId": "font-v46-montserrat-600-normal",
    "family": "Montserrat",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      400,
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "montserrat-latin-600-normal.woff",
    "byteLength": 20548,
    "sha256": "97EC588256114183969B5F3D3A53CE26D9BEB1F04C8373C866F318AFC85638C0",
    "sourcePackage": "@fontsource/montserrat",
    "packageVersion": "5.2.8",
    "sourceFile": "files/montserrat-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2011 The Montserrat Project Authors (https://github.com/JulietaUla/Montserrat) Montserrat-Italic[wght].ttf: Copyright 2011 The Montserrat Project Authors (https://github.com/JulietaUla/Montserrat)",
    "licenseFile": "montserrat-OFL-1.1.txt"
  },
  {
    "id": "v46-poppins-600-normal",
    "fontAssetId": "font-v46-poppins-600-normal",
    "family": "Poppins",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      400,
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "poppins-latin-600-normal.woff",
    "byteLength": 10600,
    "sha256": "55FFFEF7B100460605349FA5215EB7DCD6E558E195D08E43EDDC64C4B27D43B3",
    "sourcePackage": "@fontsource/poppins",
    "packageVersion": "5.2.7",
    "sourceFile": "files/poppins-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-ThinItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-ExtraLight.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-ExtraLightItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Light.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-LightItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Regular.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Italic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Medium.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-MediumItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-SemiBold.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-SemiBoldItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Bold.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-BoldItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-ExtraBold.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-ExtraBoldItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-Black.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins) Poppins-BlackItalic.ttf: Copyright 2020 The Poppins Project Authors (https://github.com/itfoundry/Poppins)",
    "licenseFile": "poppins-OFL-1.1.txt"
  },
  {
    "id": "v46-raleway-600-normal",
    "fontAssetId": "font-v46-raleway-600-normal",
    "family": "Raleway",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "raleway-latin-600-normal.woff",
    "byteLength": 22792,
    "sha256": "CA1E651ABAC1CC932F45A8DAFAF7B7C312D63EBC314A3A26FB2DAD8888EDD54B",
    "sourcePackage": "@fontsource/raleway",
    "packageVersion": "5.2.8",
    "sourceFile": "files/raleway-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2010 The Raleway Project Authors (impallari@gmail.com), with Reserved Font Name \"Raleway\". Raleway-Italic[wght].ttf: Copyright 2010 The Raleway Project Authors (impallari@gmail.com), with Reserved Font Name \"Raleway\".",
    "licenseFile": "raleway-OFL-1.1.txt"
  },
  {
    "id": "v46-rubik-700-normal",
    "fontAssetId": "font-v46-rubik-700-normal",
    "family": "Rubik",
    "requestedWeight": 600,
    "weight": 700,
    "style": "normal",
    "v46AvailableWeights": [
      500,
      700
    ],
    "selectionReason": "css-nearest-above-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "rubik-latin-700-normal.woff",
    "byteLength": 24284,
    "sha256": "A99B89B0E140BC0D2619F79993BF294ACFF8CCC844C80C082D1E900C7E8A2BED",
    "sourcePackage": "@fontsource/rubik",
    "packageVersion": "5.2.8",
    "sourceFile": "files/rubik-latin-700-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2015 The Rubik Project Authors (https://github.com/googlefonts/rubik) Rubik-Italic[wght].ttf: Copyright 2015 The Rubik Project Authors (https://github.com/googlefonts/rubik)",
    "licenseFile": "rubik-OFL-1.1.txt"
  },
  {
    "id": "v46-ubuntu-700-normal",
    "fontAssetId": "font-v46-ubuntu-700-normal",
    "family": "Ubuntu",
    "requestedWeight": 600,
    "weight": 700,
    "style": "normal",
    "v46AvailableWeights": [
      500,
      700
    ],
    "selectionReason": "css-nearest-above-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "ubuntu-latin-700-normal.woff",
    "byteLength": 18256,
    "sha256": "90E9438ED9AB43F03B5EFB8687AB4A905CA49150724EAA988A72315801AD4F7E",
    "sourcePackage": "@fontsource/ubuntu",
    "packageVersion": "5.2.8",
    "sourceFile": "files/ubuntu-latin-700-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "UFL-1.0",
    "licenseUrl": "http://font.ubuntu.com/ufl/",
    "licenseAttribution": "Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-LightItalic.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-Regular.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-Italic.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-Medium.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-MediumItalic.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-Bold.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0 Ubuntu-BoldItalic.ttf: Copyright 2011 Canonical Ltd. Licensed under the Ubuntu Font Licence 1.0",
    "licenseFile": "ubuntu-UFL-1.0.txt"
  },
  {
    "id": "v46-playfair-display-600-normal",
    "fontAssetId": "font-v46-playfair-display-600-normal",
    "family": "Playfair Display",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "playfair-display-latin-600-normal.woff",
    "byteLength": 28356,
    "sha256": "5798AA5A8BAB09880D5E1DD9BFBC8E952FB0C80EC78E695CC339E15F006E8BB8",
    "sourcePackage": "@fontsource/playfair-display",
    "packageVersion": "5.2.8",
    "sourceFile": "files/playfair-display-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2017 The Playfair Display Project Authors (https://github.com/clauseggers/Playfair-Display), with Reserved Font Name \"Playfair Display\". PlayfairDisplay-Italic[wght].ttf: Copyright 2017 The Playfair Display Project Authors (https://github.com/clauseggers/Playfair-Display), with Reserved Font Name \"Playfair Display\".",
    "licenseFile": "playfair-display-OFL-1.1.txt"
  },
  {
    "id": "v46-cormorant-garamond-600-normal",
    "fontAssetId": "font-v46-cormorant-garamond-600-normal",
    "family": "Cormorant Garamond",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "cormorant-garamond-latin-600-normal.woff",
    "byteLength": 31304,
    "sha256": "6D837BA78B1D06E83248201BFC5DE93B6E1C67AED36820021CFF3DB9602542C8",
    "sourcePackage": "@fontsource/cormorant-garamond",
    "packageVersion": "5.2.11",
    "sourceFile": "files/cormorant-garamond-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2015 The Cormorant Project Authors (github.com/CatharsisFonts/Cormorant) CormorantGaramond-Italic[wght].ttf: Copyright 2015 The Cormorant Project Authors (github.com/CatharsisFonts/Cormorant)",
    "licenseFile": "cormorant-garamond-OFL-1.1.txt"
  },
  {
    "id": "v46-lora-600-normal",
    "fontAssetId": "font-v46-lora-600-normal",
    "family": "Lora",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "lora-latin-600-normal.woff",
    "byteLength": 26812,
    "sha256": "E395F87029FF87A7850F15959C4E64DC941C90DF34EFB3AEA1AC8624AA3327B7",
    "sourcePackage": "@fontsource/lora",
    "packageVersion": "5.2.8",
    "sourceFile": "files/lora-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2011 The Lora Project Authors (https://github.com/cyrealtype/Lora-Cyrillic), with Reserved Font Name \"Lora\". Lora-Italic[wght].ttf: Copyright 2011 The Lora Project Authors (https://github.com/cyrealtype/Lora-Cyrillic), with Reserved Font Name \"Lora\".",
    "licenseFile": "lora-OFL-1.1.txt"
  },
  {
    "id": "v46-merriweather-700-normal",
    "fontAssetId": "font-v46-merriweather-700-normal",
    "family": "Merriweather",
    "requestedWeight": 600,
    "weight": 700,
    "style": "normal",
    "v46AvailableWeights": [
      700
    ],
    "selectionReason": "css-nearest-above-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "merriweather-latin-700-normal.woff",
    "byteLength": 66668,
    "sha256": "FC0FAA60DED2CE579B56E069B13802E5F2C08047E60CC5D1B7B5B1038E9775AF",
    "sourcePackage": "@fontsource/merriweather",
    "packageVersion": "5.2.11",
    "sourceFile": "files/merriweather-latin-700-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2024 The Merriweather Project Authors (https://github.com/EbenSorkin/Merriweather4) with Reserved Font Name \"Merriweather\". Merriweather-Italic[opsz,wdth,wght].ttf: Copyright 2024 The Merriweather Project Authors (https://github.com/EbenSorkin/Merriweather4) with Reserved Font Name \"Merriweather\".",
    "licenseFile": "merriweather-OFL-1.1.txt"
  },
  {
    "id": "v46-libre-baskerville-700-normal",
    "fontAssetId": "font-v46-libre-baskerville-700-normal",
    "family": "Libre Baskerville",
    "requestedWeight": 600,
    "weight": 700,
    "style": "normal",
    "v46AvailableWeights": [
      700
    ],
    "selectionReason": "css-nearest-above-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "libre-baskerville-latin-700-normal.woff",
    "byteLength": 25408,
    "sha256": "414B8A6F40B1DAC9403158D9A488FF65CA35CCD8BB2E693187F9E6F7C2E155C6",
    "sourcePackage": "@fontsource/libre-baskerville",
    "packageVersion": "5.2.10",
    "sourceFile": "files/libre-baskerville-latin-700-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2012 The Libre Baskerville Project Authors (https://github.com/impallari/Libre-Baskerville) LibreBaskerville-Italic[wght].ttf: Copyright 2012 The Libre Baskerville Project Authors (https://github.com/impallari/Libre-Baskerville)",
    "licenseFile": "libre-baskerville-OFL-1.1.txt"
  },
  {
    "id": "v46-cinzel-600-normal",
    "fontAssetId": "font-v46-cinzel-600-normal",
    "family": "Cinzel",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "cinzel-latin-600-normal.woff",
    "byteLength": 17504,
    "sha256": "7CFFB40D1C02861FD0F2FEDF9446F36B9D38CE312C723927667EBCFFC8690894",
    "sourcePackage": "@fontsource/cinzel",
    "packageVersion": "5.2.8",
    "sourceFile": "files/cinzel-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2020 The Cinzel Project Authors (https://github.com/NDISCOVER/Cinzel)",
    "licenseFile": "cinzel-OFL-1.1.txt"
  },
  {
    "id": "v46-roboto-slab-600-normal",
    "fontAssetId": "font-v46-roboto-slab-600-normal",
    "family": "Roboto Slab",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "roboto-slab-latin-600-normal.woff",
    "byteLength": 18100,
    "sha256": "010855FC5373F86C8E6B6BFCDB2C45CCAF3B3AFF332745BEDF4ACF72EFF2D8D5",
    "sourcePackage": "@fontsource/roboto-slab",
    "packageVersion": "5.2.8",
    "sourceFile": "files/roboto-slab-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "Apache-2.0",
    "licenseUrl": "http://www.apache.org/licenses/LICENSE-2.0",
    "licenseAttribution": "Copyright 2018 The Roboto Slab Project Authors (https://github.com/googlefonts/robotoslab)",
    "licenseFile": "roboto-slab-Apache-2.0.txt"
  },
  {
    "id": "v46-oswald-700-normal",
    "fontAssetId": "font-v46-oswald-700-normal",
    "family": "Oswald",
    "requestedWeight": 600,
    "weight": 700,
    "style": "normal",
    "v46AvailableWeights": [
      500,
      700
    ],
    "selectionReason": "css-nearest-above-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "oswald-latin-700-normal.woff",
    "byteLength": 16076,
    "sha256": "C11372171AEBA96BE006BE958454D0A5556793EB3CDD526F421813C28A88D99A",
    "sourcePackage": "@fontsource/oswald",
    "packageVersion": "5.2.8",
    "sourceFile": "files/oswald-latin-700-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2016 The Oswald Project Authors (https://github.com/googlefonts/OswaldFont)",
    "licenseFile": "oswald-OFL-1.1.txt"
  },
  {
    "id": "v46-bebas-neue-400-normal",
    "fontAssetId": "font-v46-bebas-neue-400-normal",
    "family": "Bebas Neue",
    "requestedWeight": 600,
    "weight": 400,
    "style": "normal",
    "v46AvailableWeights": [
      400
    ],
    "selectionReason": "only-loaded-face",
    "format": "woff",
    "subset": "latin",
    "assetFile": "bebas-neue-latin-400-normal.woff",
    "byteLength": 11180,
    "sha256": "144F4A2FEB4F333E5960703EF6A09BFE6633ABBFE1B204E3EE512803EEFFEB67",
    "sourcePackage": "@fontsource/bebas-neue",
    "packageVersion": "5.2.7",
    "sourceFile": "files/bebas-neue-latin-400-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2019 The Bebas Neue Project Authors (https://github.com/dharmatype/Bebas-Neue)",
    "licenseFile": "bebas-neue-OFL-1.1.txt"
  },
  {
    "id": "v46-anton-400-normal",
    "fontAssetId": "font-v46-anton-400-normal",
    "family": "Anton",
    "requestedWeight": 600,
    "weight": 400,
    "style": "normal",
    "v46AvailableWeights": [
      400
    ],
    "selectionReason": "only-loaded-face",
    "format": "woff",
    "subset": "latin",
    "assetFile": "anton-latin-400-normal.woff",
    "byteLength": 15632,
    "sha256": "8B71C21962CD08B95FC2186386B121D853DE5F7E02DB382ED329C5A80A04C4D1",
    "sourcePackage": "@fontsource/anton",
    "packageVersion": "5.2.7",
    "sourceFile": "files/anton-latin-400-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2020 The Anton Project Authors (https://github.com/googlefonts/AntonFont.git)",
    "licenseFile": "anton-OFL-1.1.txt"
  },
  {
    "id": "v46-caveat-600-normal",
    "fontAssetId": "font-v46-caveat-600-normal",
    "family": "Caveat",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "caveat-latin-600-normal.woff",
    "byteLength": 62544,
    "sha256": "657F46AA5EBB21C220C3C84C134DB87E5D22289746424D55DE6B28136EE6159E",
    "sourcePackage": "@fontsource/caveat",
    "packageVersion": "5.2.8",
    "sourceFile": "files/caveat-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2014 The Caveat Project Authors (https://github.com/googlefonts/caveat)",
    "licenseFile": "caveat-OFL-1.1.txt"
  },
  {
    "id": "v46-dancing-script-600-normal",
    "fontAssetId": "font-v46-dancing-script-600-normal",
    "family": "Dancing Script",
    "requestedWeight": 600,
    "weight": 600,
    "style": "normal",
    "v46AvailableWeights": [
      600,
      700
    ],
    "selectionReason": "exact-600",
    "format": "woff",
    "subset": "latin",
    "assetFile": "dancing-script-latin-600-normal.woff",
    "byteLength": 31184,
    "sha256": "FD74B1492D30E24B6E8BDD63E1CA7AA41A17E757901AF8924D18AC6558B1EB99",
    "sourcePackage": "@fontsource/dancing-script",
    "packageVersion": "5.2.8",
    "sourceFile": "files/dancing-script-latin-600-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2016 The Dancing Script Project Authors (https://github.com/googlefonts/DancingScript), with Reserved Font Name 'Dancing Script'.",
    "licenseFile": "dancing-script-OFL-1.1.txt"
  },
  {
    "id": "v46-pacifico-400-normal",
    "fontAssetId": "font-v46-pacifico-400-normal",
    "family": "Pacifico",
    "requestedWeight": 600,
    "weight": 400,
    "style": "normal",
    "v46AvailableWeights": [
      400
    ],
    "selectionReason": "only-loaded-face",
    "format": "woff",
    "subset": "latin",
    "assetFile": "pacifico-latin-400-normal.woff",
    "byteLength": 27100,
    "sha256": "4FD3A495C0B99E9279BC36DA2BC82D827DAA8EAEA1974094A8EF97131ACBCB03",
    "sourcePackage": "@fontsource/pacifico",
    "packageVersion": "5.2.7",
    "sourceFile": "files/pacifico-latin-400-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2018 The Pacifico Project Authors (https://github.com/googlefonts/Pacifico)",
    "licenseFile": "pacifico-OFL-1.1.txt"
  },
  {
    "id": "v46-great-vibes-400-normal",
    "fontAssetId": "font-v46-great-vibes-400-normal",
    "family": "Great Vibes",
    "requestedWeight": 600,
    "weight": 400,
    "style": "normal",
    "v46AvailableWeights": [
      400
    ],
    "selectionReason": "only-loaded-face",
    "format": "woff",
    "subset": "latin",
    "assetFile": "great-vibes-latin-400-normal.woff",
    "byteLength": 34852,
    "sha256": "70DB84EC82761FA328D65649439E2F9603ECBDAF0A397863875F62C43158A523",
    "sourcePackage": "@fontsource/great-vibes",
    "packageVersion": "5.2.8",
    "sourceFile": "files/great-vibes-latin-400-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2010 The Great Vibes Pro Project Authors (https://github.com/googlefonts/great-vibes)",
    "licenseFile": "great-vibes-OFL-1.1.txt"
  },
  {
    "id": "v46-lobster-400-normal",
    "fontAssetId": "font-v46-lobster-400-normal",
    "family": "Lobster",
    "requestedWeight": 600,
    "weight": 400,
    "style": "normal",
    "v46AvailableWeights": [
      400
    ],
    "selectionReason": "only-loaded-face",
    "format": "woff",
    "subset": "latin",
    "assetFile": "lobster-latin-400-normal.woff",
    "byteLength": 21856,
    "sha256": "256DEAB80B17190F594A7DAA66C58373D528D7FB0468ADAB04094B7253E0E6FF",
    "sourcePackage": "@fontsource/lobster",
    "packageVersion": "5.2.8",
    "sourceFile": "files/lobster-latin-400-normal.woff",
    "sourceUrl": "https://github.com/google/fonts",
    "licenseType": "OFL-1.1",
    "licenseUrl": "https://openfontlicense.org",
    "licenseAttribution": "Copyright 2010 The Lobster Project Authors (https://github.com/impallari/The-Lobster-Font), with Reserved Font Name \"Lobster\".",
    "licenseFile": "lobster-OFL-1.1.txt"
  }
] as const satisfies readonly V46FontProfile[];
